import SpaceUserService from "@/services/spaceUser/spaceUser.service";
const _spaceUserService = new SpaceUserService();

const enableUserAction = (
  { commit },
  { spaceId, data, callback, callbackError }
): void => {
  _spaceUserService
    .enableSpaceUser(spaceId, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const changePermissionsAction = (
  { commit },
  { spaceId, data, callback }
): void => {
  _spaceUserService
    .updateSpaceUserPermissions(spaceId, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const getNumberOfUsersInWebinarAction = (
  { commit },
  { roomId, callback }
): void => {
  _spaceUserService
    .getNumberOfUsersInWebinar(roomId)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const getSpaceUsersInWebinarAction = (
  { commit },
  { roomId, page, search, callback }
): void => {
  _spaceUserService
    .getSpaceUsersInWebinar(roomId, page, search)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const changeCollectionPermissionsAction = ({ commit }, { data, callback }) => {
  _spaceUserService
    .updateCollectionSpaceUserPermissions(data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};
const deleteSpaceUserAction = ({ commit }, { spaceUserId, callback }): void => {
  _spaceUserService
    .deleteSpaceUser(spaceUserId)
    .then(() => {
      callback();
    })
    .catch((error) => {
      console.log(error);
    });
};

const getMoveToRoom = (
  { commit },
  { spaceId, callback, callbackError }
): void => {
  _spaceUserService
    .getMoveToRoom(spaceId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const changeHostPermissionsAction = (
  { commit },
  { spaceId, data, callback }
): void => {
  _spaceUserService
    .updateSpaceUserHostPermissions(spaceId, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

export default {
  enableUserAction,
  changePermissionsAction,
  deleteSpaceUserAction,
  getNumberOfUsersInWebinarAction,
  getSpaceUsersInWebinarAction,
  changeCollectionPermissionsAction,
  getMoveToRoom,
  changeHostPermissionsAction,
};
